// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.firebase-upload {
  margin-bottom: 1rem;
}
.firebase-upload .upload-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}
.firebase-upload .upload-document-container {
  border: 2px dashed #bbb;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  background: #fafafa;
}
.firebase-upload .upload-document-container:hover {
  background-color: #f0f8ff;
  border-color: #3b82f6;
}
.firebase-upload .upload-document-container .upload-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #0066cc;
}
.firebase-upload .upload-progress {
  margin-top: 0.5rem;
}
.firebase-upload .upload-progress .progress-bar {
  background: #e0e0e0;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
}
.firebase-upload .upload-progress .progress-bar .progress {
  background: #0066cc;
  height: 100%;
}
.firebase-upload .upload-progress span {
  font-size: 0.8rem;
}
.firebase-upload .uploaded-file {
  margin-top: 0.5rem;
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f5ff;
  border-radius: 0.25rem;
}
.firebase-upload .uploaded-file a {
  color: #0066cc;
  text-decoration: underline;
}
.firebase-upload .uploaded-file .cancel-upload-button {
  background: transparent;
  color: red;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/FireBaseUploader/FirebaseUploader.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AACJ;AAEE;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,yBAAA;EACA,qBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AADN;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAHN;AAKM;EACE,mBAAA;EACA,YAAA;AAHR;AAOI;EACE,iBAAA;AALN;AASE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAPJ;AAQI;EACE,cAAA;EACA,0BAAA;AANN;AAQI;EACE,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AANN","sourcesContent":[".firebase-upload {\n  margin-bottom: 1rem;\n\n  .upload-label {\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    display: block;\n  }\n\n  .upload-document-container {\n    border: 2px dashed #bbb;\n    padding: 1rem;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 8px;\n    background: #fafafa;\n\n    &:hover {\n      background-color: #f0f8ff;\n      border-color: #3b82f6;\n    }\n\n    .upload-icon-container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.5rem;\n      color: #0066cc;\n    }\n  }\n\n  .upload-progress {\n    margin-top: 0.5rem;\n\n    .progress-bar {\n      background: #e0e0e0;\n      height: 6px;\n      border-radius: 3px;\n      overflow: hidden;\n\n      .progress {\n        background: #0066cc;\n        height: 100%;\n      }\n    }\n\n    span {\n      font-size: 0.8rem;\n    }\n  }\n\n  .uploaded-file {\n    margin-top: 0.5rem;\n    padding: 0.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f0f5ff;\n    border-radius: 0.25rem;\n    a {\n      color: #0066cc;\n      text-decoration: underline;\n    }\n    .cancel-upload-button {\n      background: transparent;\n      color: red;\n      border: none;\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
